import { IEmployee } from "@/features/organization/employees";
import { create } from "zustand";
import { persist } from "zustand/middleware";

type DataStore = {
  isSidebarCollapsed: boolean;
  toggleSidebarCollapsed: () => void;

  isSidebarOpen: boolean;
  toggleSidebarOpen: () => void;
  closeSidebar: () => void;

  isSearchAccordionCollapsed: boolean;
  toggleIsSearchAccordionCollapsed: () => void;

  currentEmployee: IEmployee | undefined;
  setCurrentEmployee: (employee: IEmployee | undefined) => void;

  userConfigs: Record<string, string>;
  hasLoadedUserConfigs: boolean;
  setUserConfigs: (configs: Record<string, string>) => void;
  setCachedUserConfig: (key: string, value: string) => void;
  setHasLoadedUserConfigs: (value: boolean) => void;
};

const useDataStore = create<DataStore>()(
  persist(
    (set) => ({
      isSidebarCollapsed: false,
      toggleSidebarCollapsed: () =>
        set((state) => ({ isSidebarCollapsed: !state.isSidebarCollapsed })),

      isSidebarOpen: false,
      toggleSidebarOpen: () =>
        set((state) => ({ isSidebarOpen: !state.isSidebarOpen })),
      closeSidebar: () => set({ isSidebarOpen: false }),

      isSearchAccordionCollapsed: true,
      toggleIsSearchAccordionCollapsed: () =>
        set((state) => ({
          isSearchAccordionCollapsed: !state.isSearchAccordionCollapsed,
        })),

      currentEmployee: undefined,
      setCurrentEmployee: (employee: IEmployee | undefined) =>
        set({ currentEmployee: employee }),

      userConfigs: {},
      hasLoadedUserConfigs: false,
      setUserConfigs: (configs: Record<string, string>) =>
        set({ userConfigs: configs }),
      setCachedUserConfig: (key: string, value: string) =>
        set((state) => ({
          userConfigs: {
            ...state.userConfigs,
            [key]: value,
          },
        })),
      setHasLoadedUserConfigs: (value: boolean) =>
        set({ hasLoadedUserConfigs: value }),
    }),
    {
      name: "payroll-ui-state",
      partialize: (state) => ({
        isSidebarCollapsed: state.isSidebarCollapsed,
      }),
    }
  )
);

export default useDataStore;
